// eslint-disable-next-line @github-ui/github-monorepo/filename-convention
export const ModelPickerManufacturer = {
  OpenAI: 'OpenAI',
  Anthropic: 'Anthropic',
  Google: 'Google',
  xAI: 'xAI',
} as const

export type ModelPickerManufacturer = (typeof ModelPickerManufacturer)[keyof typeof ModelPickerManufacturer]

export const ModelPickerItemId = {
  GPT5: 'gpt-5',
  GPT5_1: 'gpt-5.1',
  GPT5Mini: 'gpt-5-mini',
  GPT5_2: 'gpt-5.2',
  GPT4_1: 'gpt-4.1',
  GPT4o: 'gpt-4o',
  // eslint-disable-next-line camelcase
  GPT5_1CodexMax: 'gpt-5.1-codex-max',

  Sonnet4: 'sonnet-4',
  // eslint-disable-next-line camelcase
  Sonnet4_5: 'sonnet-4.5',
  // eslint-disable-next-line camelcase
  Haiku4_5: 'haiku-4.5',
  // eslint-disable-next-line camelcase
  Opus4_1: 'opus-4.1',
  // eslint-disable-next-line camelcase
  Opus4_5: 'opus-4.5',

  // eslint-disable-next-line camelcase
  Gemini2_5Pro: 'gemini-2.5-pro',
  Gemini3Pro: 'gemini-3-pro',
  Gemini3Flash: 'gemini-3-flash',

  GrokCodeFast1: 'grok-code-fast-1',
} as const

export type ModelPickerItemId = (typeof ModelPickerItemId)[keyof typeof ModelPickerItemId]

export interface ModelPickerItem {
  id: ModelPickerItemId
  label: string
  manufacturer: ModelPickerManufacturer
  isPreview?: boolean
  isFree?: boolean
}

export interface ModelPickerItemGroup {
  groupLabel: string
  items: ModelPickerItem[]
}
